import { defineStore } from 'pinia'


export const useSectionStore = defineStore('sections', {
state: () => ({
    openedSection: null,
    sections: [],
    closedPositions: [],
    isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}),
actions: {
    scrollTo(index){
        if(window.innerHeight < 500)return;
        const y = this.closedPositions[index];
        window.scrollTo({top: y, behavior: 'smooth'});
        //element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
    },
    addSection(section){
        const offset = -75;
        const y = section.getBoundingClientRect().top + window.pageYOffset + offset;
        this.sections.push(section);
        this.closedPositions.push(y);
    },
    openSection(index){
        this.openedSection = index;
    },
    closeSection(){
        this.openedSection = null;
    }
}
});